import './dialog.less'

export default ({
  content = '',
  buttonText = '我知道了',
  handleConfirm = null
} = {}) => {
  const template = `
    <div class="login-custody-dialog-wrapper" id="dialogCustody">
      <div class="login-custody-mask"></div>
        <div class="login-custody-dialog">
          <div class="login-custody-close" id="dialogClose"></div>
          <div class="login-custody-content">
            <p class="login-custody-text">${content}</p>
          </div>
          <div class="login-custody-footer">
            <a id="dialogConfirm" href="javascript:;" class="login-custody-btn">${buttonText}</a>
          </div>
        </div>
      </div>
    </div>
  `
  const alertDiv = document.createElement('div')
  alertDiv.innerHTML = template
  document.body.appendChild(alertDiv)
  setTimeout(() => {
    document.getElementById('dialogCustody').className =
      'login-custody-dialog-wrapper show'
  }, 0)

  document.getElementById('dialogClose').addEventListener('click', () => {
    alertDiv.parentNode.removeChild(alertDiv)
  })

  document.getElementById('dialogConfirm').addEventListener('click', () => {
    alertDiv.parentNode.removeChild(alertDiv)
    handleConfirm && handleConfirm()
  })
}
